import React from 'react';
import {
  HomeIcon,
  DocumentTextIcon,
  SignalIcon,
  ChartBarIcon,
  DocumentDuplicateIcon,
  ClockIcon,
  CheckCircleIcon,
  Cog6ToothIcon,
  BellIcon,
  CreditCardIcon,
  CodeBracketIcon,
  UserGroupIcon,
  BuildingOfficeIcon,
  UsersIcon,
  ShareIcon,
  CalendarIcon,
  PlusCircleIcon,
  Square3Stack3DIcon,
  FolderIcon,
  PhotoIcon,
  CubeIcon,
  SparklesIcon,
  TableCellsIcon,
  CalendarDaysIcon
} from '@heroicons/react/24/outline';

export const menuConfig = [
  {
    items: [
      {
        label: 'Dashboard',
        icon: <HomeIcon className="w-5 h-5" />,
        to: '/dashboard'
      }
    ]
  },
  {
    label: 'CONTENT',
    items: [
      {
        label: 'Documents',
        icon: <FolderIcon className="w-5 h-5" />,
        to: '/content/documents'
      },
      {
        label: 'Media',
        icon: <PhotoIcon className="w-5 h-5" />,
        to: '/content/media'
      },
    ]
  },
  {
    label: 'AUTOMATION',
    items: [
      {
        label: 'Workflows',
        icon: <Square3Stack3DIcon className="w-5 h-5" />,
        to: '/workflows'
      },
      {
        label: 'Products',
        icon: <CubeIcon className="w-5 h-5" />,
        to: '/products'
      }
    ]
  },
  {
    label: 'SCHEDULING',
    items: [
      {
        label: 'Connections',
        icon: <ShareIcon className="w-5 h-5" />,
        to: '/connections'
      },
      {
        label: 'Schedules',
        icon: <ClockIcon className="w-5 h-5" />,
        to: '/schedules'
      },
      {
        label: 'Calendar',
        icon: <CalendarDaysIcon className="w-5 h-5" />,
        to: '/content/calendar'
      }
    ]
  },
  {
    label: 'Settings',
    items: [
      {
        label: 'Usage',
        to: '/settings/usage',
        icon: <ChartBarIcon className="w-5 h-5" />,
      }
    ]
  } 
]; 